export function formatDuration(totalSeconds?: number | null): string {
  if (totalSeconds == null || Number.isNaN(Number(totalSeconds))) return '-';
  const seconds = Math.max(0, Math.floor(Number(totalSeconds)));
  const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
  const s = String(seconds % 60).padStart(2, '0');
  return `${h}:${m}:${s}`;
}

export function formatTimestamp(value?: string | null): string {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
}

export function secondsSince(value?: string | null, now = Date.now()): number | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return Math.max(0, Math.floor((now - date.getTime()) / 1000));
}

export function formatAge(value?: string | null, now = Date.now()): string {
  const seconds = secondsSince(value, now);
  if (seconds == null) return '-';
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  return `${Math.floor(minutes / 60)}h`;
}
